import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null) {
      child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
      child.current?.child.current?.setState({ moduleId: parameter });
      setTimeout(() => {
        child.current?.getSectionDataByDefault();

        if (child.current?.customForm.current != null) {
          //获取SubJobMetaType下拉菜单数据
          httpClient
            .get('/Admin/SubJobMetaType/GetSelectOptionList?moduleId=' + parameter)
            .then(({ data }) => {
              if (data.result) {
                let componentDataSource = child.current?.customForm.current?.state.componentDataSource;
                componentDataSource.SubJobMetaTypeId = data.data;
                child.current?.customForm.current?.setState({ componentDataSource });
                child.current?.customForm.current?.formRef.current?.setFieldValue('SubJobMetaTypeId', 0);
              } else {
                globalFunction.handleResultError(data, pageComponent);
              }
            })
            .catch(function (error) {
              globalFunction.handleError(error, pageComponent);
            });

            httpClient
            .get('/Admin/SubJobInternalNoteTemplate/GetSelectOptionList?moduleId=' + parameter)
            .then(({ data }) => {
              if (data.result) {
                let componentDataSource = child.current?.customForm.current?.state.componentDataSource;
                componentDataSource.SubJobInternalNoteTemplateId = data.data;
                child.current?.customForm.current?.setState({ componentDataSource });
                child.current?.customForm.current?.formRef.current?.setFieldValue('SubJobInternalNoteTemplateId', 0);
              } else {
                globalFunction.handleResultError(data, pageComponent);
              }
            })
            .catch(function (error) {
              globalFunction.handleError(error, pageComponent);
            });
        }
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'SubJobType') {
      child.current?.setState({ showModal: true, componentType: 'Create' });
      setTimeout(() => {
        child.current?.customForm.current?.formRef.current?.setFieldValue('SubJobMetaTypeId', 0);
        // 重置新增的 Internal Note Template 默认值为未选择
        child.current?.customForm.current?.formRef.current?.setFieldValue('SubJobInternalNoteTemplateId', 0);
      }, config.setTimeoutMilliSecond);
    }
  })
}

//弹出管理SubJobChecklistTemplate的div
export function manageSubJobChecklistTemplate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageSubJobChecklistTemplateShow: true, subJobTypeData: parameter });
  setTimeout(() => {
    pageComponent.subJobChecklistTemplate.current?.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}
